import React from 'react';
import classnames from 'classnames';

import { IconShapeTick } from '@xingternal/malt-icon';
import { Flavour } from '@xingternal/flavour';

import styles from './StepCounter.css';

const createRangeArray = length => [...Array(length).keys()];

const StepCounter = ({
  numberOfSteps = 4,
  currentStep = 0,
  allComplete = false,
}) => {
  if (allComplete) {
    currentStep = numberOfSteps;
  }
  return (
    <div className={styles.stepCounterContainer}>
      {createRangeArray(numberOfSteps).map(idx => [
        idx === currentStep && (
          <div className={styles.stepCounterItem} key={idx}>
            {idx + 1}
          </div>
        ),
        idx > currentStep && (
          <div
            className={classnames(styles.stepCounterItem, styles.futureItem)}
            key={idx}
          >
            {idx + 1}
          </div>
        ),
        idx < currentStep && (
          <div
            className={classnames(styles.stepCounterItem, styles.pastItem)}
            key={idx}
          >
            <Flavour flavour={'odl'}>
              <IconShapeTick size={12} />
            </Flavour>
          </div>
        ),
        idx !== numberOfSteps - 1 && (
          <div
            key={`separator${idx}`}
            className={styles.stepCounterSeparator}
          />
        ),
      ])}
    </div>
  );
};

export default StepCounter;
